var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLargeThumbnailsViewIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  fill: "none"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 0,
  width: 24,
  height: 24
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.2 12.6h6.6a.6.6 0 0 1 .6.6v7.5a.6.6 0 0 1-.6.6h-6.6a.6.6 0 0 1-.6-.6v-7.5a.6.6 0 0 1 .6-.6Zm-9 0h6.6a.6.6 0 0 1 .6.6v7.5a.6.6 0 0 1-.6.6H4.2a.6.6 0 0 1-.6-.6v-7.5a.6.6 0 0 1 .503-.592L4.2 12.6Zm9-9.9h6.6a.6.6 0 0 1 .6.6v7.5a.6.6 0 0 1-.6.6h-6.6a.6.6 0 0 1-.6-.6V3.3a.6.6 0 0 1 .6-.6Zm-9 0h6.6a.6.6 0 0 1 .6.6v7.5a.6.6 0 0 1-.6.6H4.2a.6.6 0 0 1-.6-.6V3.3a.6.6 0 0 1 .503-.592L4.2 2.7Z",
  fill: "currentColor",
  fillRule: "nonzero"
}))));
export default SvgLargeThumbnailsViewIcon;